var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFileProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 30",
    width: "26px",
    height: "30px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -140.219498, -101.368996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 140.209 101.499 L 140.209 131.239 L 166.229 131.239 L 166.229 108.939 L 158.789 108.939 L 158.789 101.499 L 140.209 101.499 Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M 166.23 114.509 L 158.79 108.939 L 166.23 108.939 L 166.23 114.509 Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 158.79 101.499 L 166.23 108.939 L 158.79 108.939 L 158.79 101.499 Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 147.45 121.359 L 145.79 122.359 L 146.43 118.759 L 149.81 120.029 L 148.27 120.919 C 149.145 121.978 150.38 122.676 151.739 122.879 C 153.097 123.082 154.483 122.776 155.63 122.019 L 156.14 122.799 C 154.774 123.692 153.123 124.039 151.514 123.772 C 149.905 123.505 148.454 122.644 147.45 121.359 Z M 158.6 119.749 L 160.26 120.749 L 156.83 121.989 L 156.22 118.359 L 157.77 119.249 C 157.999 118.628 158.117 117.971 158.12 117.309 C 158.12 116.271 157.83 115.253 157.285 114.37 C 156.739 113.487 155.958 112.774 155.03 112.309 L 155.45 111.479 C 156.53 112.02 157.438 112.851 158.072 113.879 C 158.706 114.907 159.041 116.091 159.04 117.299 C 159.049 118.123 158.9 118.942 158.6 119.709 L 158.6 119.749 Z M 151.6 110.899 L 151.6 108.939 L 154.39 111.289 L 151.6 113.579 L 151.6 111.799 C 150.301 112.019 149.122 112.692 148.272 113.699 C 147.423 114.706 146.958 115.982 146.96 117.299 C 146.96 117.409 146.96 117.519 146.96 117.629 L 146.03 117.689 C 146.03 117.559 146.03 117.429 146.03 117.299 C 146.029 115.731 146.595 114.215 147.625 113.031 C 148.654 111.848 150.076 111.076 151.63 110.859 L 151.6 110.899 Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileProcessing);
export default __webpack_public_path__ + "static/media/Icon_File_processing.e980c98e9859c07de23bc6279422d704.svg";
export { ForwardRef as ReactComponent };